// Shared helpers + constants for the Radius Server module

export function fmtDateTime(v) {
  if (!v) return '—';
  try {
    const d = new Date(v);
    if (isNaN(d.getTime())) return String(v);
    return d.toLocaleString('id-ID', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
  } catch { return String(v); }
}

export function fmtDuration(sec) {
  if (sec == null) return '—';
  const s = Number(sec);
  if (isNaN(s)) return '—';
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const ss = s % 60;
  if (h > 0) return `${h}j ${m}m`;
  if (m > 0) return `${m}m ${ss}d`;
  return `${ss}d`;
}

export const ACTION_LABELS = {
  create_user: 'Create User', edit_user: 'Edit User', change_password: 'Change Password',
  enable_user: 'Enable User', disable_user: 'Disable User', delete_user: 'Delete User',
  create_nas: 'Create NAS', edit_nas: 'Edit NAS', delete_nas: 'Delete NAS',
  create_group: 'Create Group', edit_group: 'Edit Group', delete_group: 'Delete Group',
  freeradius_reload: 'Reload FreeRADIUS',
};

export const NAS_TYPES = ['mikrotik', 'cisco', 'other', 'ubnt', 'juniper'];
export const MIKROTIK_GROUP_OPTIONS = ['full', 'write', 'read'];
